import { render, staticRenderFns } from "./MediaPackageCodeTable.vue?vue&type=template&id=2ac9e5fa&"
import script from "./MediaPackageCodeTable.vue?vue&type=script&lang=js&"
export * from "./MediaPackageCodeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports